import { Checkbox } from "components/Form/Checkbox";
import TableAction from "components/TableAction/TableAction";
import TableActions from "components/TableAction/TableActions";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

// PDF.js için worker ayarı
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function SessionExamApprovalViewModal({ show, onHide, data, onSuccess }) {
  const [checked, setChecked] = useState(false);

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header>
        <Modal.Title>Sınav Yönergesi</Modal.Title>
        <button className="btn btn-secondary" onClick={onHide}>
          Vazgeç
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-center">
          <PDFRenderer fileUrl={data.fileUrl} />
        </div>
        <div className="row mt-8">
          <div className="col-12 d-flex justify-content-end">
            <div className="d-flex">
              <Checkbox
                isSelected={checked}
                onChange={() => {
                  setChecked(!checked);
                }}
              />
              <label className="ml-2 lms-text-elipsis my-auto mr-4">Okudum</label>
            </div>

            <button
              className="btn btn-info"
              disabled={!checked}
              onClick={() => {
                onSuccess(data?.values);
              }}
            >
              Kaydet
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const PDFRenderer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setNumPages(null);
    setPageNumber(null);
  }, [fileUrl]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const handlePagePagination = (value) => {
    if (value === "prev") {
      if (pageNumber > 1) {
        setPageNumber(pageNumber - 1);
      }
    }
    if (value === "next") {
      if (pageNumber < numPages) {
        setPageNumber(pageNumber + 1);
      }
    }
  };

  return (
    <>
      {fileUrl && (
        <div className="px-4 d-flex flex-column justify-content-center align-items-center">
          <div className="d-flex justify-content-center">
            <TableActions>
              <TableAction
                id="onceki-sayfa"
                title="Önceki Sayfa"
                icon="mdiChevronLeft"
                onClick={() => handlePagePagination("prev")}
              ></TableAction>
              <span className="font-size-sm text-secondary ml-4 mr-4">
                {pageNumber || "-"} / {numPages || "-"}
              </span>
              <TableAction
                id="sonraki-sayfa"
                title="Sonraki Sayfa"
                icon="mdiChevronRight"
                onClick={() => handlePagePagination("next")}
              ></TableAction>
            </TableActions>
          </div>
          <div
            className="shadow-lg w-100 d-flex justify-content-center lms-scrollbar mt-4"
            style={{ maxHeight: "55rem" }}
          >
            <Document
              file={fileUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={"Yükleniyor..."}
              error="PDF dosyası bulunamadı. Lütfen kurumla iletişime geçiniz..."
              onError={(err) => err}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          </div>
        </div>
      )}
    </>
  );
};
